var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-tabs",
        { attrs: { type: "border-card" } },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("ChannelManagement.cron.Week") } },
            [
              _c("CrontabWeek", {
                ref: "cronweek",
                attrs: { check: _vm.checkNumber, cron: _vm.contabValueObj },
                on: { update: _vm.updateContabValue },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          staticStyle: { "margin-top": "10px" },
          attrs: { type: "border-card" },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("ChannelManagement.cron.Hour") } },
            [
              _c("CrontabHour", {
                ref: "cronhour",
                attrs: { check: _vm.checkNumber, cron: _vm.contabValueObj },
                on: { update: _vm.updateContabValue },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }